module.exports = __webpack_public_path__ + "assets/db200bcdccaa7d410a3dc278800528a1.png";